export default "__VITE_ASSET__8bd40f26__"